import i18n from '../i18n'

/**
 * The Persian-digit rule (docs/design-system.md, "قاعدهٔ اعداد"): Persian
 * numerals for anything the learner reads as a count or score (scores,
 * streaks, minutes); Latin numerals for anything they type or read off a
 * device/SMS (time codes, playback speed, phone numbers, OTP codes). Mirrors
 * `Numerals.fa()` in the Android app exactly — this must not drift between
 * clients since the rule is about what a number *means*, not which screen
 * it's on.
 *
 * That rule is itself Persian-locale-only: in the English UI, a count or
 * score reads in plain Latin digits like everything else on the page, so
 * this reads the active language rather than always converting.
 */

const PERSIAN_DIGITS = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']

/** A count/score for display — e.g. faDigits(86) === '۸۶' in fa, '86' in en. */
export function faDigits(value) {
  const text = String(value)
  if (i18n.language !== 'fa') return text
  return text.replace(/[0-9]/g, (digit) => PERSIAN_DIGITS[Number(digit)])
}
